  <div class='row row--valign-center'>
    <div class='column--8'>
      <h3>{{ isEditing ? 'Edit' : 'Create' }} Site Tour</h3>
    </div>
    <div class='column--4 align-right'>
      <button mat-icon-button color='primary' (click)='dismissDrawer()'><mat-icon>close</mat-icon></button>
    </div>
  </div>

  <form [formGroup]="form" *ngIf="!loading">
    <div class='row'>
      <div class='column--12'>
        <h3>Tour Details</h3>
      </div>
    </div>
    <div class='row'>
      <div class='column--12'>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" id="tour_name" required>
          <mat-error *ngIf="form.get('name')?.errors?.['required']">
            Tour name is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class='row'>
      <div class='column--12'>
        <mat-checkbox
          [checked]="form.get('isActive')?.value === 1"
          (change)="form.get('isActive')?.setValue($event.checked ? 1 : 0)">
          Active
        </mat-checkbox>
      </div>
    </div>
    <div class='row mb--md'>
      <div class='column--12'>
        <mat-checkbox
          [checked]="form.get('multipage')?.value === 1"
          (change)="form.get('multipage')?.setValue($event.checked ? 1 : 0)">
          Multi-page Tour
        </mat-checkbox>
      </div>
    </div>
    <div class='row'>
      <div class='column--12'>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Page Slug</mat-label>
          <input matInput formControlName="pageSlug" id="pageSlug" required>
        </mat-form-field>
      </div>
    </div>
    <div class='row'>
      <div class='column--12'>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Settings</mat-label>
          <textarea matInput formControlName="settings" [placeholder]='settingsPlaceholder' rows="3"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class='row'>
      <div class='column--12'>
        <h3>Tour Steps</h3>
      </div>
    </div>
    <div class='row'>
      <div class='column--12'>
        <div *ngIf="steps.length === 0, else hasSteps" class="empty-steps">
          <p class="mat-body-1">No steps added yet. Click "Add Step" to create your first tour step.</p>
        </div>
        <ng-template #hasSteps>
          <div formArrayName="steps" class='mb--md'>
            <div *ngFor="let step of steps.controls; let i = index" [formGroupName]="i" class="step-container">
              <mat-expansion-panel [expanded]="step.get('id').value ? false : true" class='no-radius'>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Step {{ i + 1 }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="step-content">
                  <div class='row'>
                    <div class='column--12'>
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Title</mat-label>
                        <textarea matInput [id]="'stepTitle' + i" formControlName="title" rows="3" required></textarea>
                        <mat-error *ngIf="step.get('title')?.errors?.['required']">
                          Step title is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class='row'>
                    <div class='column--12'>
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Content</mat-label>
                        <textarea matInput [id]="'stepContent' + i" formControlName="content" rows="3" required></textarea>
                        <mat-error *ngIf="step.get('content')?.errors?.['required']">
                          Step content is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class='row' *ngIf="form.get('multipage')?.value === 1">
                    <div class='column--12'>
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Page Slug</mat-label>
                        <input matInput [id]="'stepPageSlug' + i" formControlName="pageSlug">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class='row'>
                    <div class='column--12 mb--md'>
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Element Selector</mat-label>
                        <input matInput [id]="'elementSelector' + i" formControlName="elementSelector">
                        <mat-hint class='text--sm'>CSS selector for the element to highlight (e.g., #header, .navbar)</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class='row'>
                    <div class='column--12'>
                      <mat-form-field appearance="outline" class='full-width'>
                        <mat-label>Link URL</mat-label>
                        <input matInput [id]="'linkUrl' + i" formControlName="linkUrl">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class='row'>
                    <div class='column--12'>
                      <mat-form-field appearance="outline" class='full-width'>
                        <mat-label>Link Label</mat-label>
                        <input matInput [id]="'linkLabel' + i" formControlName="linkLabel">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class='row'>
                    <div class='column--12'>
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Settings</mat-label>
                        <textarea matInput [id]="'stepSettings' + i" formControlName="settings" [placeholder]='stepSettingsPlaceholder' rows="3"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <mat-action-row>
                  <button mat-button color="warn" type="button" (click)="removeStep(i)">
                    <mat-icon>delete</mat-icon> Remove Step
                  </button>
                </mat-action-row>
              </mat-expansion-panel>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class='row'>
      <div class='column--12 align-right'>
        <button mat-raised-button color="primary" type="button" (click)="addStep()" class="add-step-btn">
          <mat-icon>add_circle</mat-icon> Add Step
        </button>
      </div>
    </div>

    <!-- Form Actions -->
    <div class="row mt--md">
      <div class='column--6'>
        <button mat-flat-button color='accent' (click)='dismissDrawer()' [disabled]="isSubmitting">Cancel</button>
      </div>
      <div class='column--6 align-right'>
        <button mat-raised-button color="primary" type="button" (click)='onSubmit()' [disabled]="isSubmitting || form.invalid">
          <mat-spinner *ngIf="isSubmitting" diameter="20" class="spinner-button"></mat-spinner>
          <span>{{ isEditing ? 'Update' : 'Create' }} Tour</span>
        </button>
      </div>
    </div>
  </form>
